import { batch, signal } from "@preact/signals-react"

import { disabledCommonFiltersSubmit } from "@signals"
import { sellerDeepDiveOffersFilters, sellerDeepDiveChartActualPrice } from "./shareMBL"


export const isEmpty = signal(false)
export const elementsInLoading = signal([])


export const resetMarketplacesSellerDeepDive = () => batch(() => {
	disabledCommonFiltersSubmit.value = false
	isEmpty.value = false
	sellerDeepDiveOffersFilters.value = {}
	sellerDeepDiveChartActualPrice.value = true
})